// Map a country name (as entered by orgs) to a flag emoji.
// Returns "" when unknown so callers can fall back gracefully.
const NAME_TO_ISO = {
  "afghanistan": "AF", "albania": "AL", "algeria": "DZ", "andorra": "AD", "angola": "AO",
  "argentina": "AR", "armenia": "AM", "australia": "AU", "austria": "AT", "azerbaijan": "AZ",
  "bahamas": "BS", "bahrain": "BH", "bangladesh": "BD", "barbados": "BB", "belarus": "BY",
  "belgium": "BE", "belize": "BZ", "benin": "BJ", "bhutan": "BT", "bolivia": "BO",
  "bosnia": "BA", "bosnia and herzegovina": "BA", "botswana": "BW", "brazil": "BR", "brunei": "BN",
  "bulgaria": "BG", "burkina faso": "BF", "burundi": "BI", "cambodia": "KH", "cameroon": "CM",
  "canada": "CA", "cape verde": "CV", "chad": "TD", "chile": "CL", "china": "CN",
  "colombia": "CO", "comoros": "KM", "congo": "CG", "costa rica": "CR", "croatia": "HR",
  "cuba": "CU", "cyprus": "CY", "czech republic": "CZ", "czechia": "CZ", "denmark": "DK",
  "djibouti": "DJ", "dominican republic": "DO", "ecuador": "EC", "egypt": "EG", "el salvador": "SV",
  "estonia": "EE", "eswatini": "SZ", "ethiopia": "ET", "fiji": "FJ", "finland": "FI",
  "france": "FR", "gabon": "GA", "gambia": "GM", "georgia": "GE", "germany": "DE",
  "ghana": "GH", "greece": "GR", "greenland": "GL", "guatemala": "GT", "guinea": "GN",
  "guyana": "GY", "haiti": "HT", "honduras": "HN", "hong kong": "HK", "hungary": "HU",
  "iceland": "IS", "india": "IN", "indonesia": "ID", "iran": "IR", "iraq": "IQ",
  "ireland": "IE", "israel": "IL", "italy": "IT", "ivory coast": "CI", "jamaica": "JM",
  "japan": "JP", "jordan": "JO", "kazakhstan": "KZ", "kenya": "KE", "kosovo": "XK",
  "kuwait": "KW", "kyrgyzstan": "KG", "laos": "LA", "latvia": "LV", "lebanon": "LB",
  "lesotho": "LS", "liberia": "LR", "libya": "LY", "liechtenstein": "LI", "lithuania": "LT",
  "luxembourg": "LU", "madagascar": "MG", "malawi": "MW", "malaysia": "MY", "maldives": "MV",
  "mali": "ML", "malta": "MT", "mauritania": "MR", "mauritius": "MU", "mexico": "MX",
  "moldova": "MD", "monaco": "MC", "mongolia": "MN", "montenegro": "ME", "morocco": "MA",
  "mozambique": "MZ", "myanmar": "MM", "burma": "MM", "namibia": "NA", "nepal": "NP",
  "netherlands": "NL", "new zealand": "NZ", "nicaragua": "NI", "niger": "NE", "nigeria": "NG",
  "north korea": "KP", "north macedonia": "MK", "macedonia": "MK", "norway": "NO", "oman": "OM",
  "pakistan": "PK", "palestine": "PS", "panama": "PA", "papua new guinea": "PG", "paraguay": "PY",
  "peru": "PE", "philippines": "PH", "poland": "PL", "portugal": "PT", "qatar": "QA",
  "romania": "RO", "russia": "RU", "rwanda": "RW", "samoa": "WS", "saudi arabia": "SA",
  "senegal": "SN", "serbia": "RS", "sierra leone": "SL", "singapore": "SG", "slovakia": "SK",
  "slovenia": "SI", "somalia": "SO", "south africa": "ZA", "south korea": "KR", "korea": "KR",
  "south sudan": "SS", "spain": "ES", "sri lanka": "LK", "sudan": "SD", "suriname": "SR",
  "sweden": "SE", "switzerland": "CH", "syria": "SY", "taiwan": "TW", "tajikistan": "TJ",
  "tanzania": "TZ", "thailand": "TH", "togo": "TG", "tonga": "TO", "trinidad and tobago": "TT",
  "tunisia": "TN", "turkey": "TR", "turkiye": "TR", "türkiye": "TR", "turkmenistan": "TM",
  "uganda": "UG", "ukraine": "UA", "united arab emirates": "AE", "uae": "AE",
  "united kingdom": "GB", "uk": "GB", "great britain": "GB", "england": "GB",
  "united states": "US", "united states of america": "US", "usa": "US", "us": "US", "america": "US",
  "uruguay": "UY", "uzbekistan": "UZ", "vatican": "VA", "venezuela": "VE", "vietnam": "VN",
  "yemen": "YE", "zambia": "ZM", "zimbabwe": "ZW",
};

export function normalizeCountry(name) {
  return (name || "")
    .replace(/[^\p{L}\s]/gu, "")
    .split(",").pop()
    .trim()
    .toLowerCase();
}

export function flagEmoji(name) {
  const iso = NAME_TO_ISO[normalizeCountry(name)];
  if (!iso) return "";
  return iso.toUpperCase().replace(/./g, (c) => String.fromCodePoint(127397 + c.charCodeAt(0)));
}
